import { yup } from '@framework/validation/initYup.ts';

export interface IMetadataDirective {
  /**
   * Abilita l'esportazione come metadato, nella tabella dedicata.
   */
  enabled?: boolean | null;
  /**
   * Indica se il campo deve essere ricercabile (verrà concatenato come stringa
   * agli altri campi con lo stesso flag, per la ricerca estesa)
   */
  searchable?: boolean | null;
  /**
   * Tag semantico associato al campo.
   */
  semanticTag?: string | null;
}

export const MetadataDirectiveSchema: yup.ObjectSchema<IMetadataDirective> = yup
  .object({
    enabled: yup
      .boolean()
      .notRequired()
      .transform(value => value ?? false)
      .default(false)
      .label('Abilita esportazione'),
    searchable: yup
      .boolean()
      .notRequired()
      .label('Campo ricercabile')
      .when(['enabled'], ([enabled], schema) =>
        enabled
          ? schema.enabled(true)
          : schema.transform(() => false).enabled(false),
      ),
    semanticTag: yup
      .string()
      .notRequired()
      .label('Tag semantico')
      .when(['enabled'], ([enabled], schema) =>
        enabled
          ? schema.enabled(true)
          : schema.transform(() => null).enabled(false),
      ),
  })
  .noUnknown();

export interface IMetadataDirectiveSchemaMeta {
  export: boolean;
  searchable: boolean;
  semanticTag?: string | null;
  /** ID del Widget */
  widgetId: string;
  /** Tipo del widget */
  widgetType: string;
  /** Tipo di dato del widget */
  type: string;
}

/**
 * Chiave meta che dichiara i campi sibling da aggregare nel `value` del
 * metadato esportato del campo root. I sibling elencati non vengono esportati
 * come metadati a sé.
 */
export const ExportedMetadataSiblingPathsMetaKey =
  'exportedMetadataSiblingPaths';

/**
 * Prefisso fisso delle chiavi del `value` esportato per un campo con sibling:
 * `root` è il campo principale, `root@<suffisso>` ogni sibling. Sostituisce
 * il codice del widget, così il payload non dipende dalla configurazione.
 */
export const ExportedMetadataRootKey = 'root';
